// src/components/ThankYou.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ThankYou = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/login'); 
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="container mt-5">
      {/* Hero Section */}
      <div className="text-center p-5 mb-5">
        <div className="mb-4">
          <img src="/logo192.png" alt="Taxi-Local.uk" style={{ maxWidth: '150px' }} />
        </div>
        <h1 className="fw-bold mb-2">Taxi-Local.uk</h1>
        <p className="lead mb-0">
          Linking local taxis and clients in real-time
        </p>
      </div>

      <div className="text-center mt-5">
        <h2>Thank You for Subscribing!</h2>
        <p>You will be redirected shortly...</p>
      </div>
    </div>
  );
};

export default ThankYou;
